var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.disabledSaved
    ? _c("c-loader", {
        staticClass: "new-calculation-loader",
        attrs: {
          label: "Производится сохранение",
          active: _vm.disabledSaved,
          height: 500,
        },
      })
    : _c(
        "div",
        { staticClass: "delivery" },
        [
          _c("m-table-settings", {
            attrs: {
              columns: _vm.tableData.columns,
              "disabled-columns": _vm.tableData.disabledColumns,
              "default-disabled-columns": _vm.tableData.defaultDisabledColumns,
              "with-grouped": "",
            },
            on: { submit: _vm.submitTableSettings },
            model: {
              value: _vm.tableSettingsModal,
              callback: function ($$v) {
                _vm.tableSettingsModal = $$v
              },
              expression: "tableSettingsModal",
            },
          }),
          _c("m-production-write-fine-premium", {
            attrs: {
              "calculation-type": _vm.tab,
              "calc-data": _vm.data,
              "table-records": _vm.tableData.records,
              active: _vm.isShowModalProductionWriteFinePremium,
              "is-delivery-tab": true,
            },
            on: {
              writeFineBonusAllWorkers: _vm.writeFineBonusAllWorkers,
              close: function ($event) {
                _vm.isShowModalProductionWriteFinePremium = false
              },
            },
          }),
          _c("m-production-add-workers", {
            attrs: {
              "modal-title": "Добавить водителей",
              active: _vm.isShowModalAddWorkers,
              workers: _vm.driversLocalItems,
              selected: _vm.driversLocalItemsSelected,
              "table-records": _vm.tableData.records,
              data: _vm.data,
              "is-delivery-tab": true,
              tab: _vm.tab,
              "group-code": "'driver'",
            },
            on: {
              submitWorkers: _vm.submitWorkers,
              close: function ($event) {
                _vm.isShowModalAddWorkers = false
              },
            },
          }),
          _c("m-production-create-worker", {
            attrs: {
              "modal-title": "Создать водителя",
              "is-delivery-tab": true,
              active: _vm.isShowModalCreateWorker,
              "calculation-type": _vm.tab,
              data: _vm.data,
            },
            on: {
              createNewWorker: _vm.createNewWorker,
              close: function ($event) {
                _vm.isShowModalCreateWorker = false
              },
            },
          }),
          _c("div", { staticClass: "delivery-header" }, [
            _c(
              "div",
              { staticClass: "delivery-header-buttons-left" },
              [
                _c("c-button-dropdown", {
                  staticClass: "delivery-header-buttons-left-drivers",
                  class: {
                    "delivery-header-buttons-left-drivers-disabled":
                      _vm.dataIsLoading || !_vm.canEdit,
                  },
                  attrs: {
                    icon: "arrow",
                    type: "dropdown",
                    disabled: _vm.dataIsLoading || !_vm.canEdit,
                    label: "Водители",
                    dropdown: {
                      position: "right",
                      items: [
                        { label: "Добавить водителей", emit: "addDrivers" },
                        { label: "Новый водитель", emit: "createDriver" },
                      ],
                    },
                  },
                  on: {
                    addDrivers: _vm.showModalAddDrivers,
                    createDriver: _vm.openCreateDriverModal,
                  },
                }),
                _vm.tab !== "byPeriod"
                  ? _c("c-button", {
                      staticClass:
                        "delivery-header-buttons-left-recalculate-routes",
                      attrs: {
                        icon: "routes",
                        label: "Пересчитать маршруты",
                        disabled: _vm.dataIsLoading,
                        size: "small",
                        responsive: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.recountRoutes()
                        },
                      },
                    })
                  : _vm._e(),
                _c("c-button", {
                  staticClass: "delivery-header-buttons-left-fine-rewarding",
                  attrs: {
                    disabled:
                      !_vm.isThereWorkersInTable ||
                      _vm.dataIsLoading ||
                      !_vm.canEdit,
                    label:
                      _vm.tab === "byPeriod"
                        ? "Штраф/премия"
                        : "Штраф/премия смене",
                    color: "white",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowModalProductionWriteFinePremium = true
                    },
                  },
                }),
                false && _vm.tab !== "byPeriod"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "delivery-header-buttons-left-holiday-allowance",
                      },
                      [
                        _c("c-input", {
                          staticClass:
                            "delivery-header-buttons-left-holiday-allowance-input",
                          attrs: {
                            placeholder: "Праздничная надбавка",
                            type: "price-number",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "delivery-header-buttons-left-holiday-allowance-percent",
                          },
                          [_vm._v("%")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "delivery-header-buttons-right" },
              [
                _c("c-button", {
                  attrs: {
                    responsive: "",
                    size: "small",
                    disabled: _vm.dataIsLoading || !_vm.canEdit,
                    label: "Настроить столбцы",
                    icon: "cog",
                    type: "with-icon",
                  },
                  on: {
                    click: function ($event) {
                      _vm.tableSettingsModal = true
                    },
                  },
                }),
                _c("c-button", {
                  staticClass: "delivery-header-buttons-right-less",
                  attrs: {
                    label: "Меньше информации",
                    disabled: _vm.dataIsLoading || _vm.currentColumnLevel === 1,
                    icon: "less",
                    color: "white",
                    size: "small",
                  },
                  on: { click: _vm.lessInformation },
                }),
                _c("c-button", {
                  staticClass: "delivery-header-buttons-right-more",
                  attrs: {
                    label: "Больше информации",
                    disabled: _vm.dataIsLoading || _vm.currentColumnLevel === 3,
                    icon: "more",
                    color: "white",
                    size: "small",
                  },
                  on: { click: _vm.moreInformation },
                }),
              ],
              1
            ),
          ]),
          !_vm.dataIsLoading
            ? _c("c-data-table-delivery", {
                ref: "table",
                staticClass: "delivery-table",
                attrs: {
                  levels: 1,
                  "disabled-columns": _vm.tableData.disabledColumns,
                  data: _vm.tableData,
                  "calculation-data": _vm.data,
                  "calculation-type": _vm.tab,
                  "is-delivery-tab": true,
                  "personal-reasons": _vm.personalReasons,
                  "can-edit": _vm.canEdit,
                },
                on: {
                  productionRemoveWorkerFromCalc: _vm.removeWorker,
                  updateFines: _vm.updateFines,
                  changeDriver: _vm.changeDriver,
                  recountDriver: _vm.recountDriver,
                  updateBonuses: _vm.updateBonuses,
                  updateKPItable: _vm.updateKPItable,
                  updatePersonal: _vm.updatePersonal,
                },
              })
            : _vm._e(),
          !_vm.dataIsLoading && (_vm.canEdit || _vm.canClose || _vm.isClosed)
            ? _c(
                "div",
                { staticClass: "delivery-actions-row" },
                [
                  _vm.canClose
                    ? _c("c-button", {
                        staticClass: "delivery-actions-row__toggle-closed",
                        class: {
                          "delivery-actions-row__toggle-closed--active":
                            !_vm.isClosed,
                        },
                        attrs: {
                          size: "large",
                          disabled: _vm.isTogglingClosed,
                          label: _vm.isClosed
                            ? "Открыть расчёт"
                            : "Закрыть расчёт",
                          color: _vm.isClosed ? "primary" : undefined,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("toggleClosed")
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.isClosed
                    ? _c(
                        "span",
                        { staticClass: "delivery-actions-row__closed-badge" },
                        [_vm._v("Расчёт закрыт")]
                      )
                    : _vm._e(),
                  _vm.canEdit
                    ? _c("responsive-apply-reset-actions", {
                        staticClass: "delivery-actions",
                        class: { "no-shadow": !_vm.displayActionShadows },
                        attrs: { "disable-submit": _vm.disabledSaved },
                        on: {
                          "on-submit": _vm.saveCalculation,
                          "on-reset": _vm.cancelCalculation,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.dataIsLoading
            ? _c("c-loader", {
                staticClass: "delivery-loader",
                attrs: {
                  label: "Данные загружаются",
                  active: _vm.dataIsLoading,
                  height: "300",
                },
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }